/**
 * The words of an import of per part costs (B2; components/settings/PartCostsImport): what a check would do, or what an
 * import did. Pure. No dash anywhere.
 */
import type { PartCostImport } from "@/lib/api/part-costs";
import { count } from "@/lib/brief/words";

export const plural = (n: number, one: string, many: string) => `${count(n)} ${n === 1 ? one : many}`;

/** A cost in the plant's currency, to the cent: "USD 12.50". */
export const costText = (v: number, currency: string) =>
  `${currency} ${v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** What a check would do, or what an import did, in one sentence. */
export function partCostsHeadline(r: PartCostImport): string {
  const changing = r.priced.filter((p) => !p.unchanged).length;
  if (r.dry_run) {
    return `The file prices ${count(r.priced.length)} of its ${plural(r.rows, "row", "rows")}: ${plural(changing, "part", "parts")} would change and ${count(r.unchanged)} ${r.unchanged === 1 ? "is" : "are"} already at its cost. Nothing is written yet.`;
  }
  if (r.written === 0) return "Every part the file prices is already at its cost: nothing changed.";
  return `Priced ${plural(r.written, "part", "parts")}; ${count(r.unchanged)} ${r.unchanged === 1 ? "was" : "were"} already at its cost. The briefs price their scrap with them at the next analysis.`;
}
